import {
    type GetSubEventForAdminResponseType,
    type GetSubEventForAdminRequestType
} from "./type";
import {
    request
} from "../request";

const getSubEventForAdmin = async (params: GetSubEventForAdminRequestType): Promise<GetSubEventForAdminResponseType> => {
    return await request<GetSubEventForAdminResponseType>(`/events/getSubEventForAdmin?eventSubID=${params.eventSubID}&eventID=${params.eventID}`, {
        method: "GET"
    });
};

export default getSubEventForAdmin;
